import { Logo } from "../../components/shared";
import { ApplicationDocuments } from "../../components/ApplicationDocuments";
import { useAuth } from "../../context/AuthContext";
import { Clock3 } from "lucide-react";

export default function VendorPending() {
  const { logout } = useAuth();

  return (
    <main className="min-h-screen bg-slate-50 px-4 py-10">
      <section className="mx-auto max-w-lg border border-slate-200 bg-white p-8" data-testid="vendor-pending-page">
        <Logo />
        <Clock3 className="mt-10 h-8 w-8 text-amber-700" />
        <p className="mt-5 text-xs font-semibold uppercase tracking-wide text-amber-700">Application submitted</p>
        <h1 className="mt-2 font-display text-3xl font-bold">Your Vendor application is under review</h1>
        <p className="mt-4 text-sm leading-6 text-slate-600">
          Your application is safely recorded and under review. We will send a secure activation invitation
          after approval. Your Vendor Portal is unavailable until then.
        </p>
        <ApplicationDocuments className="mt-7" />
        <button
          className="mt-7 inline-block text-sm font-semibold text-emerald-800 hover:underline"
          data-testid="vendor-pending-sign-out"
          onClick={logout}
          type="button"
        >
          Sign out and return home
        </button>
      </section>
    </main>
  );
}